import QuizzesEntity, { IQuizzesParams } from "./QuizzesEntity";
import SummaryEntity, { ISummaryParams } from "./SummaryEntity";

export const quizzesEntity = (params: IQuizzesParams) =>
  new QuizzesEntity({ ...params });

export const summaryEntity = (params: ISummaryParams) =>
  new SummaryEntity({ ...params });
